import { ArrowPathIcon } from '@heroicons/react/24/outline';
import type { ComponentType } from 'react';

export interface ActionTileProps {
    icon: ComponentType<{ className?: string }>;
    label: string;
    onSelect: () => void;
    disabled?: boolean;
    disabledReason?: string;
    loading?: boolean;
}

/**
 * Square action tile for the patient overview "Actions" tab — a dashboard-local
 * recreation of files-viewer's ActionCard (see ActionCard.tsx there for the
 * shared visual spec), extended with a loading state.
 */
export function ActionTile({
    icon: Icon,
    label,
    onSelect,
    disabled,
    disabledReason,
    loading = false
}: ActionTileProps) {
    const isDisabled = disabled || loading;

    return (
        <button
            type="button"
            onClick={onSelect}
            disabled={isDisabled}
            title={isDisabled && disabledReason ? disabledReason : undefined}
            className={
                isDisabled
                    ? 'w-24 min-h-[88px] flex flex-col items-center justify-center gap-1.5 px-2 py-3 bg-white border border-gray-200 rounded-xl opacity-40 cursor-not-allowed transition-colors flex-shrink-0'
                    : 'w-24 min-h-[88px] flex flex-col items-center justify-center gap-1.5 px-2 py-3 bg-white border border-gray-200 rounded-xl hover:border-yellow-300 hover:bg-yellow-50 transition-colors flex-shrink-0'
            }
        >
            {loading ? (
                <ArrowPathIcon className="w-5 h-5 text-yellow-600 animate-spin" />
            ) : (
                <Icon
                    className={isDisabled ? 'w-5 h-5 text-gray-400' : 'w-5 h-5 text-yellow-600'}
                />
            )}
            <span
                className="text-[11px] font-medium text-gray-700 leading-tight text-center"
                style={{ textWrap: 'balance' }}
            >
                {label}
            </span>
        </button>
    );
}
